<template>
	<section>
		<div class="add-class page__title page__title--wih-actions">
			<h1 class="classname" v-if="getClassLength !== 0">
				{{ this.$store.getters.class(this.$route.params.id) }}
			</h1>
			<div class="button__container">
				<router-link
					class="button button--secondary"
					:to="{
						name: 'StudentPlaceHome',
						params: { classId: crypt($route.params.id) },
					}">Accéder à l'espace étudiant </router-link>
				<router-link
					class="button button--secondary"
					:to="{
						name: 'EditClass',
						params: { id: this.$route.params.id },
					}">Modifier la classe</router-link>
			</div>
		</div>
		<div class="page__description no-margin">Partagez les ressources et documents à la classe, les élèves y ont accès chez eux, depuis leur espace étudiant.</div>

		<div class="parameter-container">
			<class-router />
		</div>
	</section>
</template>

<script>

import ClassRouter from './ClassRouter.vue'
import { crypt } from '../../../utils/utils'

export default {
	components: {
		ClassRouter,
	},
	data() {
		return {
			evaluations: [],
			agendas: [],
			type: '',
			selectedRessourceId: null,
		}
	},

	computed: {
		getClassLength() {
			if (this.$store.state.classes) {
				return this.$store.state.classes.length
			}
			else {
				return null
			}
		}
	},

	methods: {
		crypt: crypt,
	}

};
</script>

<style>
</style>
